import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import AdhocPaymentsPage from './AdhocPaymentsPage';
import { getOnlinePaymentInfoInitiate } from '../../../actions/payments';

const mapStateToProps = state => {
  const paymentsInfo = _get(state, 'payments.paymentInfo', {});
  return {
    paymentsInfo,
    fetchingOnlinePaymentInfo:
      _get(state, 'apiState.ONLINE_PAYMENT_INFO.isFetching', true) &&
      !_get(state, 'apiState.ONLINE_PAYMENT_INFO.isIdle', false),
    fetchedOnlinePaymentInfo: _get(
      state,
      'apiState.ONLINE_PAYMENT_INFO.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getOnlinePaymentInfo: payload =>
    dispatch(getOnlinePaymentInfoInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdhocPaymentsPage);
